import React, {memo, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {Button, Col, Row} from "react-bootstrap";

import Ticket from './Ticket';
import TicketMenu from './Ticket/TicketMenu';

const PaymentDetails = ({paymentId, onCancelPayment}) => {
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [ticketsToPrint, setTicketsToPrint] = useState([]);

  const autoPrint = parseInt(new URLSearchParams(location.search).get('print'));

  useEffect(() => {
    (async () => {
      const token = window.sessionStorage.getItem('token');
      const response = await fetch(`/payment/cash/?payment_id=${paymentId}`, {
        headers: {'Authorization': `Token ${token}`,}
      });
      if (response.status === 200) {
        const responseJson = await response.json();
        await setTickets(responseJson.tickets);
        await setTicketsToPrint(responseJson.tickets);
        if (autoPrint) {
          printTickets();
        }
      }
    })();
  }, []);

  const onPrintButtonPress = () => printTickets(tickets);

  const printTickets = () => window.print();

  const printTicket = async (ticket) => {
    await setTicketsToPrint(tickets.filter(t => t.number === ticket.number));
    window.print();
    await setTicketsToPrint(tickets);
  };

  const cancelTicket = async (ticket) => {
    if (window.confirm('Ви дійсно бажаєте анулювати квиток?')) {
      const token = window.sessionStorage.getItem('token');
      const response = await fetch(`/ticket/${ticket.number}/`, {
        method: 'DELETE',
        headers: {'Authorization': `Token ${token}`,}
      });
      if (response.status === 200) {
        window.location.replace(window.location.pathname);
      } else {
        const responseJson = await response.json();
        window.alert(responseJson);
      }
    }
  };

  return (
    <>
      <div
        className='d-flex justify-content-end'
        style={{paddingBottom: '15px'}}
      >
        <Button
          variant="outline-secondary"
          onClick={onPrintButtonPress}
        >Друк</Button>
        <Button
          variant="outline-danger"
          onClick={() => onCancelPayment(paymentId)}
        >Відміна</Button>
      </div>
      <Row className='tickets-wrapper'>
        {ticketsToPrint.map(ticket => (
          <Col
            sm={6}
            md={4}
            lg={3}
            key={ticket.number}
          >
            <Ticket
              {...ticket}
            />
            <TicketMenu
              onPrintButtonPress={() => printTicket(ticket)}
              onCancelTicketPress={() => cancelTicket(ticket)}
              // showCancelButton={ticket.status !== 'Анульований'}
            />
          </Col>
        ))}
      </Row>
    </>
  )
};

export default memo(PaymentDetails);
